import { render, staticRenderFns } from "./TaxProfiles.vue?vue&type=template&id=76cdd87d"
import script from "./TaxProfiles.vue?vue&type=script&lang=js"
export * from "./TaxProfiles.vue?vue&type=script&lang=js"
import style0 from "./TaxProfiles.vue?vue&type=style&index=0&id=76cdd87d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports